import React from "react";
import { Button } from "antd";
import CrownSubscription from "../../component/ReportBuilder/Insights/CrownSubscription";
import useShowInsights from "../../hooks/useShowInsights";

const InsightsSubcriptionButton = () => {
    const { showInsights, hasInsightPermission } = useShowInsights()
    return <>
        {!hasInsightPermission && (<Button
        // {showInsights && !hasInsightPermission && (<Button
            type="primary"
            onClick={() => {
                window.open("mailto: onemarket@sqreem.com")
            }}
            style={{
                background: "var(--blue-600)",
                padding: "1mm 3mm"
            }}
        >
            <div className="d-flex align-items-center gap-5p">
                <CrownSubscription />
                <span>Try OI Pro</span>
            </div>
        </Button>)}
    </>
}

export default InsightsSubcriptionButton